import { Routes } from '@angular/router';
import { ObservationDetailsComponent } from './observation-details.component';
import { RouteAccessService } from '../../shared';

export const OBSERVATION_DETAILS_ROUTES: Routes = [
    {
        path: 'observation-details/:observationUnitId',
        component: ObservationDetailsComponent,
        canActivate: [RouteAccessService]
    }
];
